import React, { useContext } from "react";
import { MeetingFormContext } from "../../../MeetingFormContext";
import Form from "antd/lib/form/Form";
import { Input } from "antd";

export const SubjectInput = (props: any) => {
  const meetingFormContext = useContext(MeetingFormContext);
  const { form, worktableMeeting, onInputChange } = meetingFormContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item
      label="Tema de reunión">
      {getFieldDecorator("subject", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el tema de la reunión."
          }
        ],
        initialValue: worktableMeeting?.subject
      })(
        <Input
          id="subject"
          name="subject"
          type="text"
          onChange={onChange} />
      )}
    </Form.Item>
  );
};
